"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullableJsonValue = void 0;
const tslib_1 = require("tslib");
const zod_1 = require("zod");
const transformJsonNull_1 = tslib_1.__importDefault(require("./transformJsonNull"));
const JsonValue_1 = tslib_1.__importDefault(require("./JsonValue"));
exports.NullableJsonValue = zod_1.z
    .union([JsonValue_1.default, zod_1.z.literal('DbNull'), zod_1.z.literal('JsonNull')])
    .nullable()
    .transform((v) => (0, transformJsonNull_1.default)(v));
exports.default = exports.NullableJsonValue;
//# sourceMappingURL=NullableJsonValue.js.map